var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"main-app"},[_c('h1',{on:{"click":function($event){$event.stopPropagation();return _vm.salir($event)}}},[_vm._v("SiGeMed")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }